<template>
  <v-dialog
    v-model="open"
    persistent
    :overlay="true"
    max-width="400px"
    transition="dialog-transition"
    overlay-color="#1976D2"
  >
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <p>{{ $t('recurring_debit.generating_file') }}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-progress-linear
                color="primary"
                indeterminate
                height="15"
                rounded
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['open']

}
</script>

<style>

</style>